import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';
import * as Globalization from '../../../_common/platform/ts/Globalization';
import { config } from '../ts/config';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';
import StringField from '../../../_common/platform/tsx/StringField';
import ItemActionsSelector, { IActionButton } from './menus/ItemActionsSelector';
import BooleanField from '../../../_common/platform/tsx/BooleanField';
import { IDirsInstanceState, IRenameLoading, IDirItem } from '../ts/stores/DirsStore';
import { IMarkedItems } from '../ts/Interfaces';

import {
    IDraggableItem,
    IDraggableItemData,
    handleMenuItemDragging
} from '../../../_common/platform/ts/DragDropCommon';

export interface ISelectedItem {
    type: number;
    id: string;
    title: string;
}

export enum DirsTreeModes {
    WORKSPACE_SELECT = 1,
    TEMPLATE_SELECT,
    RESOURCE_SELECT,
    USER_GROUPS_SELECT
}

export interface IDirTreeFlatProperties {
    instanceId: string;
    mode: DirsTreeModes;
    rootId?: number;
    rootName?: string;
    displayId: number;
    marked: IMarkedItems;
    canEdit: boolean;
    markMode?: boolean;
    useSearching?: boolean;
    dragDropData?: IDraggableItemData;
    disableMenu?: boolean;
    showSelectAll?: boolean;
    hideIcons?: boolean;
    glob: IGlob;

    getSelectAllState?(): boolean;
    getContentLength?(id: number): JQuery.Deferred<number>;

    onSelect(id: number, name: string): void;
    onItemDelete?(id: number): void;
    onMark?(marked: IMarkedItems): void;
    onShowActions?(): void;
    onHideActions?(): void;
    onSelectAllChange?(value: boolean): void;
}

interface IItemCommonProperties {
    item: IDirItem;
    instanceID: string;
    rename: number;
    renameLoading: IRenameLoading;
    glob: IGlob;
}

interface IActionSelectorProperties extends IItemCommonProperties {
    mode: DirsTreeModes;
    rootID: number;
    showAddFolder: boolean;

    getContentLength(id: number): JQuery.Deferred<number>;

    onAddNewFolder(id: number): void;
    onItemDelete(dirID: number): void;
    onShowActions(): void;
    onHideActions(): void;
}

interface ITreeItemProperties extends IItemCommonProperties {
    markMode: boolean;
    disableMenu: boolean;
    showPath: boolean;
    marked: boolean;
    dragDropData: IDraggableItemData;
    hideIcons: boolean;

    getActionSelector(
        item: IDirItem,
        rename: number,
        renameLoading: IRenameLoading,
        showAddFolder: boolean
    ): React.JSX.Element;

    onSelect(dirID: number, name: string): void;
    onMark(marked: boolean): void;
}

class ActionSelector extends React.Component<IActionSelectorProperties, {}> {
    getActionButtons(): IActionButton[] {
        let result: IActionButton[] = [];

        if (this.props.showAddFolder !== false) {
            result.push({
                key: 'add-folder',
                title: 'Add Folder',
                icon: 'glyphicon glyphicon-plus'
            });
        }

        result.push({
            key: 'edit-permissions',
            title: 'Edit Permissions',
            icon: 'glyphicon glyphicon-user'
        });

        const parentExists = this.props.item != null ? this.props.item.parent != null : null;

        if (parentExists) {
            result = result.concat([
                null, //Divider.
                {
                    key: 'rename',
                    title: 'Rename',
                    icon: 'glyphicon glyphicon-pencil'
                }
            ]);

            if (
                this.props.mode === DirsTreeModes.WORKSPACE_SELECT ||
                this.props.mode === DirsTreeModes.TEMPLATE_SELECT
            ) {
                result.push({
                    key: 'move',
                    title: 'Move',
                    icon: 'glyphicon glyphicon-transfer'
                });
            }

            result.push({
                key: 'delete',
                title: 'Delete',
                icon: 'glyphicon glyphicon-remove'
            });
        }

        return result;
    }

    processDelete() {
        const defs = [];

        if (typeof this.props.getContentLength === 'function') {
            defs.push(this.props.getContentLength(this.props.item.dirid));
        }

        defs.push(
            this.props.glob.AQLQueries.callMethod<any>('dir_IsHomeDir', {
                dirid: this.props.item.dirid
            })
        );

        $.when.apply($, defs).done((contentLen, isHomeDir) => {
            const key = this.props.item.dirid || this.props.item.cid;

            if (key == null || this.props.renameLoading[key] || key === this.props.rename) {
                return;
            }

            let deleteSubItemsToo = true;
            let params = {};
            let prompt;
            let homeDirPrompt = '';

            if (contentLen > 0 || this.props.item.subdirlist.length > 0) {
                deleteSubItemsToo = false;

                params = {
                    cancelTitle: 'Delete',
                    deny: true,
                    confirmTitle: '',
                    confirm: false,

                    draggable: true,
                    resizable: false,
                    minHeight: 'none'
                };

                if (isHomeDir.result === true) {
                    homeDirPrompt = ' is home directory for User and';
                } else {
                    params['Component'] = BooleanField;
                    params['componentOptions'] = {
                        onChange: (val) => (deleteSubItemsToo = val),
                        title: 'Delete including sub-folders and sub-items'
                    };
                }

                prompt = `Folder '${this.props.item.name}'${homeDirPrompt} has sub-items. Please, confirm the action.`;
            } else {
                params = {
                    cancelTitle: 'Delete',
                    deny: true,
                    confirmTitle: '',
                    confirm: false,

                    draggable: true,
                    resizable: false,
                    minHeight: 'none'
                };

                if (isHomeDir.result === true) {
                    homeDirPrompt = ' is home directory for User. It';
                }

                prompt = `Folder '${this.props.item.name}'${homeDirPrompt} is empty and can be deleted safely. Please, confirm the action.`;
            }

            //VR: here is no 'text' option. So, use 'title' instead
            //title = Delete the folder '${ this.props.obj.name }
            this.props.glob.DialogActions.createDialog(
                `Delete the folder '${this.props.item.name}'`,
                prompt,
                () => {},
                () => {
                    this.props.glob.AppActions.dirsDelete(
                        key,
                        this.props.instanceID,
                        this.props.item.name,
                        deleteSubItemsToo,
                        this.props.onItemDelete
                    );
                },
                () => {},
                'custom',
                params
            );
        });
    }

    processMove() {
        const key = this.props.item.dirid || this.props.item.cid;
        if (key == null || this.props.renameLoading[key] || key === this.props.rename) {
            return;
        }

        this.props.glob.DialogActions.createDialog(
            'Select a new parent folder for the folder "' + this.props.item.name + '"',
            '',
            (dirid) => {
                this.props.glob.AppActions.dirsMove(key, dirid, this.props.instanceID, this.props.rootID);
            },
            () => {},
            () => {},
            this.props.mode === DirsTreeModes.WORKSPACE_SELECT ? 'workspaceDirSelect' : 'templateDirSelect',
            {
                selectTitle: 'Move to selected folder',
                rootId: this.props.rootID,
                overwriteShow: false,
                allowSelectItem: false
            }
        );
    }

    processAddNewFolder(id: number) {
        if (this.props.onAddNewFolder != null) {
            if (id == null) {
                return;
            }

            if (this.props.renameLoading[id]) {
                return;
            }

            this.props.onAddNewFolder(id);
        }
    }

    handleOnActionClick = (key: string) => {
        const dirid = this.props.item.dirid || this.props.item.cid;
        if (dirid == null) {
            return;
        }

        switch (key) {
            case 'add-folder':
                this.processAddNewFolder(dirid);
                break;

            case 'rename':
                if (!this.props.renameLoading[dirid]) {
                    this.props.glob.AppActions.dirsRenameStart(dirid, this.props.instanceID);
                }
                break;

            case 'edit-permissions':
                this.props.glob.AppActions.permissionsDirShow(dirid, this.props.item.name);
                break;

            case 'move':
                this.processMove();
                break;

            case 'delete':
                this.processDelete();
                break;

            default:
                console.log('WARNING: Menu Action has no handler.');
        }
    };

    handleOnActionsClose = () => {
        if (this.props.onHideActions != null) {
            this.props.onHideActions();
        }
    };

    render() {
        return (
            <ItemActionsSelector
                className="config-button"
                buttons={this.getActionButtons()}
                glob={this.props.glob}
                onActionClick={this.handleOnActionClick}
                onShow={this.props.onShowActions}
                onClose={this.handleOnActionsClose}
            />
        );
    }
}

interface ITreeItemState {
    nameEdit: string;
    checked: boolean;
}

class TreeItem extends React.Component<ITreeItemProperties, ITreeItemState> {
    private references: {
        editField?: HTMLInputElement;
        draggableItem?: HTMLSpanElement;
    } = {};

    constructor(props) {
        super(props);

        const marked = this.props.marked != undefined && this.props.marked == true;

        this.state = {
            nameEdit: this.props.item.name,
            checked: marked
        };
    }

    setRenameState() {
        const input = this.references.editField;
        input.focus();
        $(input).select();
    }

    getDragHelper = () => {
        const clone = $(this.references.draggableItem).clone();

        clone.removeAttr('data-reactid');

        clone.find('*').each(function () {
            $(this).removeAttr('data-reactid');
        });

        return clone;
    };

    handleDragStart = (e, ui) => {
        $(this.references.draggableItem).addClass('dragging');
    };

    handleDragStop = (e, ui) => {
        $(this.references.draggableItem).removeClass('dragging');
    };

    componentDidMount() {
        if (this.props.dragDropData != null) {
            const item = this.references.draggableItem;

            $(item)
                .draggable({
                    helper: this.getDragHelper,

                    revert: true,
                    revertDuration: 0,
                    zIndex: 6,
                    addClasses: false,
                    appendTo: $('.menu-tree'),

                    start: this.handleDragStart,
                    stop: this.handleDragStop,

                    drag: handleMenuItemDragging,

                    scope: this.props.dragDropData.scope
                })
                .data('payload', {
                    itemType: this.props.dragDropData.itemType,
                    id: this.props.item.dirid,
                    name: this.props.item.name
                } as IDraggableItem);
        }

        const key = this.props.item.dirid || this.props.item.cid;

        if (this.props.rename === key) {
            this.setRenameState();
        }
    }

    getOnSelectHandler(name: string) {
        return (e) => {
            e.stopPropagation();
            e.preventDefault();

            if (typeof this.props.onSelect === 'function') {
                this.props.onSelect(this.props.item.dirid, name);
            }
        };
    }

    handleRenameClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    handleRenameChange = (e) => {
        this.setState({
            nameEdit: e.target.value
        });
    };

    handleRenameEnd = (e) => {
        const key = this.props.item.dirid || this.props.item.cid;

        this.props.glob.AppActions.dirsRenameEnd(key, this.state.nameEdit, this.props.instanceID);

        e.preventDefault();
    };

    componentDidUpdate(prevProps, prevState) {
        const key = this.props.item.dirid || this.props.item.cid;

        if (this.props.rename === key && prevProps.rename !== key) {
            this.setRenameState();
        }

        if (prevProps.marked != this.props.marked) {
            let checked = this.props.marked != undefined && this.props.marked == true;
            this.setState({ checked: checked });
        }
    }

    handleOnMarkChanged = (value: boolean) => {
        this.setState({
            checked: value
        });

        if (this.props.markMode !== true) {
            return;
        }

        if (typeof this.props.onMark === 'function') {
            this.props.onMark(value);
        }
    };

    render() {
        const { item, rename, renameLoading } = this.props;
        const key = item.dirid || item.cid;

        let title;

        if (rename === key && !renameLoading[key]) {
            // WorkItem [96290]: It is impossible to rename a Folder in BROWSE if the widget "Settings / Menu" is opened BUG
            // So, commented:                onBlur={ this.handleRenameEnd }
            title = (
                <form onSubmit={this.handleRenameEnd}>
                    <input
                        ref={(input) => {
                            this.references.editField = input;
                        }}
                        value={this.state.nameEdit}
                        onClick={this.handleRenameClick}
                        onChange={() => {}} //Is added to fix red warning.
                        onInput={this.handleRenameChange}
                    />
                </form>
            );
        } else {
            title = item.name;

            if (this.props.showPath === true) {
                let path = '';
                let parentObj = item.parent;

                while (parentObj != null && parentObj.parent != null) {
                    path = path.length > 0 ? parentObj.name + '/' + path : parentObj.name;
                    parentObj = parentObj.parent;
                }

                if (path.length > 0) {
                    title += ' (' + path + ')';
                }
            }
        }

        let actionSelector: React.JSX.Element;

        if (!item.back && this.props.disableMenu !== true) {
            actionSelector = this.props.getActionSelector(item, rename, renameLoading, false);
        }

        let markCell: React.JSX.Element;

        if (this.props.markMode === true) {
            markCell = (
                <td className="cell-mark">
                    <BooleanField value={this.state.checked} title={''} onChange={this.handleOnMarkChanged} />
                </td>
            );
        }

        let iconElement: React.JSX.Element;

        if (!this.props.hideIcons) {
            iconElement = (
                <td className="cell-icon" onClick={this.getOnSelectHandler(title)}>
                    <span className="glyphicon glyphicon-folder-close"></span>
                </td>
            );
        }

        return (
            <li
                className={
                    'dir-node-flat dropdown' +
                    (renameLoading[key] ? ' loading' : '') +
                    (this.props.dragDropData != null ? ' dragabble' : '')
                }
            >
                <div
                    className="dir-node-flat-item"
                    ref={(input) => {
                        this.references.draggableItem = input;
                    }}
                >
                    <table className="dir-node-flat-table">
                        <tbody>
                            <tr>
                                {markCell}
                                {iconElement}

                                <td className="cell-title" onClick={this.getOnSelectHandler(title)}>
                                    {title}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {actionSelector}
            </li>
        );
    }
}

interface IDirsTreeFlatState {
    searchString?: string;
}

export default class DirsTreeFlat extends React.Component<IDirTreeFlatProperties, IDirsTreeFlatState> {
    constructor(props) {
        super(props);

        this.state = {
            searchString: ''
        };
    }

    static defaultProps = {
        rootId: config.WIDGETS_ROOT_DIR_ID,
        rootName: config.WIDGETS_ROOT_DIR_NAME
    };

    componentDidMount() {
        this.props.glob.DirsStore.addChangeListener(this.handleOnDirsStoreChange);

        if (this.props.mode === DirsTreeModes.USER_GROUPS_SELECT) {
            this.props.glob.AppActions.dirsUserGroupContentLoad(
                this.props.instanceId,
                this.props.rootId,
                this.props.rootName
            );
        } else {
            this.props.glob.AppActions.dirsContentLoad(this.props.instanceId, this.props.rootId, this.props.rootName);
        }
    }

    componentWillUnmount() {
        this.props.glob.DirsStore.removeChangeListener(this.handleOnDirsStoreChange);
    }

    handleItemSelect = (id: number, name: string) => {
        if (this.props.mode === DirsTreeModes.USER_GROUPS_SELECT) {
            this.props.glob.AppActions.dirsUserGroupContentLoad(
                this.props.instanceId,
                this.props.rootId,
                this.props.rootName,
                true,
                true
            );
        } else {
            this.props.glob.AppActions.dirsContentLoad(
                this.props.instanceId,
                this.props.rootId,
                this.props.rootName,
                true,
                true
            );
        }

        this.setState({ searchString: '' });

        if (typeof this.props.onSelect === 'function') {
            this.props.onSelect(id, name);
        }
    };

    handleAddNewFolder = (id: number) => {
        this.setState({ searchString: '' });

        this.props.glob.AppActions.dirsCreateStart(id, this.props.instanceId);
    };

    handleOnDirsStoreChange = () => {
        const data = this.props.glob.DirsStore.getInstanceData(this.props.instanceId);

        if (data == null) {
            if (this.props.mode === DirsTreeModes.USER_GROUPS_SELECT) {
                this.props.glob.AppActions.dirsUserGroupContentLoad(
                    this.props.instanceId,
                    this.props.rootId,
                    this.props.rootName
                );
            } else {
                this.props.glob.AppActions.dirsContentLoad(
                    this.props.instanceId,
                    this.props.rootId,
                    this.props.rootName
                );
            }
        } else {
            this.setState(this.state);
        }
    };

    getBreadCrumbs(store: IDirsInstanceState) {
        const dirItems: IDirItem[] = [];

        let obj = store.data.dirsHash[this.props.displayId];

        do {
            dirItems.unshift(obj);
            obj = obj.parent;
        } while (obj != null);

        const showMenu = this.props.disableMenu !== true && this.props.canEdit;
        const maxIndex = dirItems.length - 1;

        const content = _.map(dirItems, (item, i) => {
            return (
                <li key={item.dirid || item.cid}>
                    <div
                        className="bread-crumb-item"
                        onClick={() => {
                            this.handleItemSelect(item.dirid, item.name);
                        }}
                    >
                        {item.name}
                    </div>

                    {showMenu && i === maxIndex
                        ? this.getActionSelector(item, store.rename, store.renameLoading, true)
                        : null}
                </li>
            );
        });

        return (
            <ol className="breadcrumb" key="breadcrumb">
                {content}
            </ol>
        );
    }

    getActionSelector = (item: IDirItem, rename: number, renameLoading: IRenameLoading, showAddFolder: boolean) => {
        return (
            <ActionSelector
                item={item}
                instanceID={this.props.instanceId}
                rename={rename}
                renameLoading={renameLoading}
                showAddFolder={showAddFolder}
                mode={this.props.mode}
                rootID={this.props.rootId}
                getContentLength={this.props.getContentLength}
                onAddNewFolder={this.handleAddNewFolder}
                onItemDelete={this.getOnItemDeleteHandler(item.dirid || item.cid)}
                onShowActions={this.props.onShowActions}
                onHideActions={this.props.onHideActions}
                glob={this.props.glob}
            />
        );
    };

    getOnMarkHandler = (id: number, name: string) => {
        return (mark: boolean) => {
            const marked = _.clone(this.props.marked);

            if (mark === true) {
                marked[id] = name;
            } else {
                delete marked[id];
            }

            if (typeof this.props.onMark === 'function') {
                this.props.onMark(marked);
            }
        };
    };

    handleSearchChange = (value: string) => {
        this.setState({ searchString: value });
    };

    getOnItemDeleteHandler(id: number) {
        return () => {
            if (typeof this.props.onItemDelete === 'function') {
                this.props.onItemDelete(id);
            }
        };
    }

    findDirItems(items: IDirItem[], searchString: string, result: IDirItem[]) {
        if (items == null) {
            return;
        }

        _.each(items, (item) => {
            if (item != null) {
                if (item.name.toLowerCase().indexOf(searchString) === 0) {
                    const itemCopy = _.clone(item);
                    result.push(itemCopy);
                }

                this.findDirItems(item.subdirlist, searchString, result);
            }
        });
    }

    render() {
        const store = this.props.glob.DirsStore.getInstanceState(this.props.instanceId);

        let content: React.JSX.Element[] | React.JSX.Element;

        if (store.loading) {
            content = <ProgressBar />;
        } else {
            const obj = store.data.dirsHash[this.props.displayId];

            if (obj != null) {
                content = [this.getBreadCrumbs(store)];

                let searchString: string;

                if (this.props.useSearching !== false) {
                    searchString = this.state.searchString;

                    content.push(
                        <div className="search-field" key="dirs-tree-search-field">
                            <StringField
                                value={searchString}
                                placeholder={'Type folder name for searching'}
                                onChange={this.handleSearchChange}
                            />
                        </div>
                    );
                }

                if (this.props.showSelectAll) {
                    content.push(
                        <div className="select-all" key="select-all">
                            <BooleanField
                                value={this.props.getSelectAllState != null ? this.props.getSelectAllState() : false}
                                allowNull={false}
                                title={Globalization.getMessage('selectAll')}
                                onChange={this.props.onSelectAllChange}
                            />
                        </div>
                    );
                }

                let dirList = [...obj.subdirlist];

                const isSearchUsed = searchString != null && searchString.length > 0;

                if (isSearchUsed) {
                    const searchResult = [];

                    this.findDirItems(dirList, searchString.toLowerCase(), searchResult);

                    dirList = searchResult;

                    if (searchResult.length === 0) {
                        content.push(
                            <div className="no-item-message" key="no-item-message">
                                <span>{'No folder is found'}</span>
                            </div>
                        );
                    }
                } else if (obj.parent != null) {
                    dirList.unshift({
                        back: true,
                        name: '..',
                        dirid: obj.parent.dirid,
                        nomark: true
                    });
                }

                if (dirList.length > 0) {
                    const disableMenu = this.props.disableMenu || !this.props.canEdit;

                    content.push(
                        <ul className="list-unstyled dirs-list-flat" key="tree">
                            {_.map(dirList, (item) => {
                                const markMode = item.nomark ? false : this.props.markMode;

                                let marked: boolean;
                                let onMarkHandler;

                                if (markMode) {
                                    marked = this.props.marked.hasOwnProperty(item.dirid);
                                    onMarkHandler = this.getOnMarkHandler(item.dirid, item.name);
                                }

                                return (
                                    <TreeItem
                                        key={item.dirid || item.cid}
                                        item={item}
                                        instanceID={this.props.instanceId}
                                        rename={store.rename}
                                        renameLoading={store.renameLoading}
                                        markMode={markMode}
                                        marked={marked}
                                        disableMenu={disableMenu}
                                        showPath={isSearchUsed}
                                        dragDropData={this.props.dragDropData}
                                        hideIcons={this.props.hideIcons}
                                        glob={this.props.glob}
                                        getActionSelector={this.getActionSelector}
                                        onSelect={this.handleItemSelect}
                                        onMark={onMarkHandler}
                                    />
                                );
                            })}
                        </ul>
                    );
                }
            }
        }

        return <div className="dirs-tree-flat">{content}</div>;
    }
}

export interface IContentItems {
    dirs: IMarkedItems;
    items: IMarkedItems;
}

export function calculateSelectAllState(
    content: IContentItems,
    markedDirs: IMarkedItems,
    markedItems: IMarkedItems
): boolean {
    if (_.isEmpty(content.dirs) && _.isEmpty(content.items)) {
        return false;
    }

    const markedDirKeys = _.keys(markedDirs);
    const markedItemKeys = _.keys(markedItems);
    const all =
        _.difference(_.keys(content.dirs), markedDirKeys).length === 0 &&
        _.difference(_.keys(content.items), markedItemKeys).length === 0;

    return all;
}
